import React from "react";
import { Box, Container, Typography, Grid, Paper } from "@mui/material";
import { ReactComponent as challenge1 } from "../../../assets/icons/challenge1.svg";
import { ReactComponent as challenge3 } from "../../../assets/icons/challenge3.svg";
import { ReactComponent as shield } from "../../../assets/icons/shield.svg";
import { ReactComponent as arrowright } from "../../../assets/icons/arrowright.svg";
import { ReactComponent as challengesub1 } from "../../../assets/icons/challengesub1.svg";
import { ReactComponent as challengesub2 } from "../../../assets/icons/challengesub2.svg";
import { ReactComponent as challengesub3 } from "../../../assets/icons/challengesub3.svg";
 
const challenges = [
  {
    problemIcon: challengesub1,
    problemText:
      "社内アプリ・ツールごとの\n月額SaaSが積み上がり\n固定費を圧迫している",
    solutionIcon: challenge1,
    solutionTitle: "既存のMicrosoft 既存のMicrosoft 365環境内に構築し、\n外部SaaSを削減",
    solutionText:
      "ほとんど使われていないツールにも、毎月のライセンス費が発生していないでしょうか。SPFxで作った機能はM365ライセンスの範囲内で動くため、SaaSの追加契約もサーバーの用意も必要ありません。ツール1本分の月額がそのまま浮いたケースもあります。",
  },
  {
    problemIcon: challengesub2,
    problemText:
      "ツールが増えるほど、\nアカウント・セキュリティ管理が\n複雑になる",
    solutionIcon: shield,
    solutionTitle: "Azure AD（Entra ID）認証への一本化",
    solutionText:
      "サービスごとにアカウントを作り、入退社のたびに棚卸しをして、それぞれのアップデートを追う。この手間は使うツールの数だけ増えていきます。SPFxは既存のAzure AD認証をそのまま使うため、ID管理はこれまでどおり1か所のまま。部門や役職に応じたアクセス制御も、SharePointの権限設定の延長で運用できます。",
  },
  {
    problemIcon: challengesub3,
    problemText:
      "スクラッチ開発は高額で、\n現場の要望にスピーディーに\n応えられない",
    solutionIcon: challenge3,
    solutionTitle: "SharePoint基盤を活かしたモジュール型開発",
    solutionText:
      "ゼロから作ると、認証もデータベースも画面基盤も一式そろえることになり、見積もりはどうしても膨らみます。SPFxはSharePointの標準基盤の上にWebパーツ単位で機能を足していく作り方なので、その分だけ初期費用と期間を抑えられます。「この項目も一覧に出したい」といったリリース後の要望も、該当のパーツだけ直せば済みます。",
  },
];
 
const ChallengesSection = () => {
  return (
    <Box
      sx={{
        backgroundColor: "#d9dcdf",
        py: { xs: 6, md: 8 },
      }}
    >
      <Container maxWidth={false} sx={{ width: "92%", mx: "auto" }}>
        <Typography
          align="center"
          sx={{
            fontWeight: 700,
            fontSize: { xs: "26px", md: "52px" },
            mb: { xs: 4, md: 6 },
          }}
        >
          SharePointをお使いの企業の <br />
          こんなお悩みを解決します
        </Typography>
 
        <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
          {challenges.map((item, index) => {
            const ProblemIcon = item.problemIcon;
            const SolutionIcon = item.solutionIcon;
 
            return (
              <Grid
                container
                spacing={{ xs: 3, md: 4 }}
                alignItems="stretch"
                key={index}
              >
                {/* Problem card + arrow */}
                <Grid
                  item
                  xs={12}
                  md={5.5}
                  sx={{ display: "flex", alignItems: "center", gap: 2 }}
                >
                  <Paper
                    elevation={0}
                    sx={{
                      flex: 1,
                      display: "flex",
                      alignItems: "center",
                      gap: 2,
                      p: "35px",
                      borderRadius: "12px",
                      backgroundColor: "#fff",
                      height: "100%",
                      boxSizing: "border-box",
                      //   minHeight: { md: 150 },
                    }}
                  >
                    <ProblemIcon
                      sx={{ fontSize: 40, color: "#FF6000", flexShrink: 0 }}
                    />
                    <Typography
                      sx={{
                        fontWeight: 700,
                        fontSize: "20px",
                        lineHeight: 1.7,
                        whiteSpace: { xs: "normal", sm: "pre-line" },
                      }}
                    >
                      {item.problemText}
                    </Typography>
                  </Paper>
 
                  <Box
                    sx={{
                      display: { xs: "none", md: "flex" },
                      alignItems: "center",
                      justifyContent: "center",
                      width: 61,
                      height: 61,
                      borderRadius: "50%",
                      backgroundColor: "#fff",
                      flexShrink: 0,
                      marginLeft: '-50px',
                      border: '1px solid #999'
                    }}
                  >
                    <Box
                      component={arrowright}
                      sx={{
                        width: 30,
                        height: 30,
                      }}
                    />
                  </Box>
                </Grid>
 
                {/* Solution card */}
                <Grid item xs={12} md={6.5}>
                  <Paper
                    elevation={0}
                    sx={{
                      display: "flex",
                      gap: 3,
                      p: 3,
                      borderRadius: "12px",
                      backgroundColor: "#fff",
                      //   height: "100%",
                    }}
                  >
                    <Box sx={{ flexShrink: 0 }}>
                      <Box
                        sx={{
                          display: "inline-block",
                          backgroundColor: "#e8e8e8",
                          borderRadius: "6px",
                          px: 1.2,
                          py: 0.4,
                          fontSize: "12px",
                          fontWeight: 700,
                          mb: 1.5,
                        }}
                      >
                        SPFxで解決
                      </Box>
                      <Box>
                        <SolutionIcon sx={{ fontSize: 56, color: "#FF6000" }} />
                      </Box>
                    </Box>
 
                    <Box>
                      <Typography
                        sx={{
                          fontWeight: 700,
                          fontSize: "18px",
                          mb: 1,
                          lineHeight: 1.5,
                        }}
                      >
                        {item.solutionTitle}
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "14px",
                          color: "rgba(0,0,0,0.75)",
                          lineHeight: 1.8,
                        }}
                      >
                        {item.solutionText}
                      </Typography>
                    </Box>
                  </Paper>
                </Grid>
              </Grid>
            );
          })}
        </Box>
      </Container>
    </Box>
  );
};
 
export default ChallengesSection;